import React, { useEffect, useState } from "react";

import { WidgetComponents } from "constants/widgets.constant";

export default function EditWidgetModal(props) {
  const { Type } = props.data;
  const [currentWidget, setCurrentWidget] = useState(null);

  useEffect(() => {
    setCurrentWidget(Type);
  }, [Type]);

  const modalClosed = data => {
    setCurrentWidget(null);
    props.onEditWidgetClose(data);
  };

  return <>{currentWidget && React.createElement(WidgetComponents[currentWidget], { onClose: modalClosed, data: props.data, admin: props.admin })}</>;
}
